// import React from "react";
// import {Container, Row, Col} from "react-bootstrap";
// import ReactHtmlParser from 'html-react-parser';
//
// function makeProfBold(text) {
//     return text.replace(/Xiaoxu Zhao/g, "<strong>Xiaoxu Zhao</strong>");
// }
//
// function PaperItem(props) {
//     return (
//         // <Container className={"paper-section"}>
//             <Row style={{margin: "3em"}}>
//                 <Col md={4}>
//                     <img src={props.image} alt={"paper"} style={{ maxWidth: '100%', height: 'auto' }}/>
//                 </Col>
//                 <Col md={8}>
//                     <p style={{fontSize: 18, fontFamily: "Poppins", textAlign: 'left', color: "hsla(42, 89%, 36%, 1)"}}>
//                         <strong>{props.index}</strong>. {props.title}
//                     </p>
//                     {/*<p dangerouslySetInnerHTML={{ __html: makeProfBold(props.author) }} />*/}
//                     <p style={{fontSize: 14, fontFamily: "Poppins", textAlign: 'left'}}>
//                         {ReactHtmlParser(makeProfBold(props.author))}
//                     </p>
//                     <p style={{fontSize: 18, fontFamily: "Poppins", textAlign: 'left'}}>
//                         {props.reference} <a href={props.link} target={"_blank"} rel="noreferrer"></a>
//                     </p>
//                 </Col>
//             </Row>
//         // </Container>
//     );
// }
//
// export default PaperItem;

import React from "react";
import { Row, Col } from "react-bootstrap";
import ReactHtmlParser from 'html-react-parser';

/**
 * Highlights the Professor's name in the author list.
 */
function makeProfBold(text) {
    if (!text) return "";
    return text.replace(/Xiaoxu Zhao/g, "<strong>Xiaoxu Zhao</strong>");
}

function PaperItem(props) {
    return (
        <Row style={{
            margin: "3em 0", // Added vertical margin, removed horizontal
            alignItems: "center" // Vertically centers the text column with the image box
        }}>
            {/* Image Column */}
            <Col md={4}>
                <div style={{
                    width: '100%',
                    height: '200px', // Fixed height for consistency
                    backgroundColor: '#fff', // Use white or #f8f9fa for a light grey look
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    border: '1px solid #eee', // Light border to define the image area
                    padding: '5px' // Space between image and border
                }}>
                    <img
                        src={props.image}
                        alt={"paper thumbnail"}
                        style={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain' // Prevents cropping, shows the full image
                        }}
                    />
                </div>
            </Col>

            {/* Text Information Column */}
            <Col md={8}>
                <div style={{ paddingLeft: '15px' }}>
                    <p style={{
                        fontSize: 18,
                        fontFamily: "Poppins",
                        textAlign: 'left',
                        color: "hsla(42, 89%, 36%, 1)",
                        marginBottom: '8px'
                    }}>
                        <strong>{props.index}.</strong> {props.title}
                    </p>

                    <p style={{
                        fontSize: 14,
                        fontFamily: "Poppins",
                        textAlign: 'left',
                        marginBottom: '8px'
                    }}>
                        {ReactHtmlParser(makeProfBold(props.author))}
                    </p>

                    <p style={{
                        fontSize: 16, // Slightly reduced for better hierarchy
                        fontFamily: "Poppins",
                        textAlign: 'left',
                        fontStyle: 'italic'
                    }}>
                        {props.reference}
                        {props.link && (
                            <a href={props.link} target={"_blank"} rel="noreferrer" style={{ marginLeft: '10px' }}>
                                [Link]
                            </a>
                        )}
                    </p>
                </div>
            </Col>
        </Row>
    );
}

export default PaperItem;